var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "step_component_wrapper"
    }
  }, [_c('clip-loader', {
    attrs: {
      "loading": _vm.loading,
      "color": 'rgb(93, 197, 150)',
      "size": "56px"
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "slot-content",
    staticStyle: {
      "max-height": "50vh",
      "padding": "0px",
      "overflow-y": "auto",
      "margin": "12px"
    }
  }, [_c('dyn-table', {
    attrs: {
      "array": _vm.list,
      "configs": _vm.tableConfigs,
      "name": _vm.tableConfigs.name,
      "rowClicked": _vm.onRowClicked,
      "focus": _vm.selected,
      "removeDecorations": true
    },
    on: {
      "update:array": function($event) {
        _vm.list = $event
      },
      "dynTableReady": _vm.getDynTableElement
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "slot-button"
  }, [(!_vm.backTo1Allowed) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.$root.logout()
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('logout', null)))]) : _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.$emit('backward')
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('back', null)))]), _vm._v(" "), (_vm.showSub) ? _c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "auto"
    },
    on: {
      "click": _vm.loadSub
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$Jed.firstUpperTranslate('load', null) + " " + _vm.$Jed.translate('model', null)) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.step7) ? _c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "disabled": _vm.selected == null
    },
    on: {
      "click": _vm.forward
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$Jed.firstUpperTranslate('confirm', null)) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.step7) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.selected == null
    },
    on: {
      "click": _vm.load
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$Jed.firstUpperTranslate('load', null)) + "\n        ")]) : _vm._e()]) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0eb14e6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loader/steps/SelezioneCatalogo.vue
// module id = 1500
// module chunks = 1